import { PureLightTheme } from "../../../../styles/theme";

export const CardInfo = {
  width: '360px',
  maxHeight: '808px',
  height: '100%',
  overflowY: 'auto',
  padding: 5,
  [PureLightTheme.breakpoints.down('md')] : {
    width: '100%',
    height: 'auto',
  },
}

export const BoxImgBadge = {
  marginRight: '15px',
}

export const CardImg = {
  height: '32px',
  width: '32px',
  objectFit: 'cover',
  borderRadius: '50%',
}

export const ButtonStyle = {
  height: "32px"
}
